// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiContainer-root MuiContainer-maxWidthSm"
      >
        <form
          accept-charset="UTF-8"
          action="/users"
          id="new_user_registration"
          method="post"
        >
          <input
            name="utf8"
            type="hidden"
            value="✓"
          />
          <input
            name="authenticity_token"
            type="hidden"
            value=""
          />
          <input
            id="registration_uuid"
            name="registration_uuid"
            type="hidden"
            value="foo"
          />
          <input
            id="activation_code"
            name="activation_code"
            type="hidden"
            value="bar"
          />
          <input
            id="province"
            name="province"
            type="hidden"
            value=""
          />
          <input
            id="sign_up_category"
            name="sign_up_category"
            type="hidden"
            value=""
          />
          <input
            id="speciality_id"
            name="speciality_id"
            type="hidden"
            value=""
          />
          <input
            id="practitioner_num"
            name="practitioner_num"
            type="hidden"
            value=""
          />
          <input
            id="phone_number"
            name="phone_number"
            type="hidden"
            value=""
          />
          <input
            id="lfp_enrolled"
            name="lfp_enrolled"
            type="hidden"
            value="false"
          />
          <input
            id="office_facility_code"
            name="office_facility_code"
            type="hidden"
            value=""
          />
          <input
            id="promo_code"
            name="promo_code"
            type="hidden"
            value="promo"
          />
          <input
            id="bill_share_guid"
            name="bill_share_guid"
            type="hidden"
            value="guid"
          />
          <input
            id="bill_share_token"
            name="bill_share_token"
            type="hidden"
            value="token"
          />
        </form>
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
        >
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <h3
              class="MuiTypography-root MuiTypography-h3"
            >
              About your Practice
            </h3>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <p
              class="MuiTypography-root MuiTypography-body1"
            >
              Let us know a bit more about your practice to finish creating your account.
            </p>
            <p
              class="MuiTypography-root makeStyles-requiredFieldTxt-6 MuiTypography-body1"
            >
              * indicates required field
            </p>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <fieldset
              class="MuiFormControl-root"
            >
              <legend
                class="MuiFormLabel-root makeStyles-legend-4 Mui-required"
              >
                Which province do you bill to?
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk"
                >
                   
                  *
                </span>
              </legend>
              <div
                aria-label="Which province do you bill to?"
                class="MuiFormGroup-root"
                role="radiogroup"
              >
                <label
                  class="MuiFormControlLabel-root makeStyles-body1-1"
                  required=""
                >
                  <span
                    aria-disabled="false"
                    class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary"
                  >
                    <span
                      class="MuiIconButton-label"
                    >
                      <input
                        class="PrivateSwitchBase-input-10"
                        name="province-AB"
                        type="radio"
                        value="AB"
                      />
                      <div
                        class="PrivateRadioButtonIcon-root-11"
                      >
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          />
                        </svg>
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root PrivateRadioButtonIcon-layer-12"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                          />
                        </svg>
                      </div>
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </span>
                  <span
                    class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                  >
                    Alberta (AHCIP)
                  </span>
                </label>
                <label
                  class="MuiFormControlLabel-root makeStyles-body1-1"
                  required=""
                >
                  <span
                    aria-disabled="false"
                    class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary"
                  >
                    <span
                      class="MuiIconButton-label"
                    >
                      <input
                        class="PrivateSwitchBase-input-10"
                        name="province-BC"
                        type="radio"
                        value="BC"
                      />
                      <div
                        class="PrivateRadioButtonIcon-root-11"
                      >
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          />
                        </svg>
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root PrivateRadioButtonIcon-layer-12"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                          />
                        </svg>
                      </div>
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </span>
                  <span
                    class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                  >
                    British Columbia (MSP)
                  </span>
                </label>
                <label
                  class="MuiFormControlLabel-root makeStyles-body1-1"
                  required=""
                >
                  <span
                    aria-disabled="false"
                    class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary"
                  >
                    <span
                      class="MuiIconButton-label"
                    >
                      <input
                        class="PrivateSwitchBase-input-10"
                        name="province-ON"
                        type="radio"
                        value="ON"
                      />
                      <div
                        class="PrivateRadioButtonIcon-root-11"
                      >
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          />
                        </svg>
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root PrivateRadioButtonIcon-layer-12"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                          />
                        </svg>
                      </div>
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </span>
                  <span
                    class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                  >
                    Ontario (OHIP)
                  </span>
                </label>
              </div>
            </fieldset>
          </div>
          <div
            class="MuiBox-root MuiBox-root-14 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            data-testid="registration-step-3-lfp-enrollment"
            style="margin-top: 30px;"
          >
            <legend
              class="MuiFormLabel-root makeStyles-legend-4"
            >
              Patient panel upload (PAS)
            </legend>
            <label
              class="MuiFormControlLabel-root"
            >
              <span
                aria-disabled="false"
                class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiCheckbox-root MuiCheckbox-colorPrimary MuiIconButton-colorPrimary"
                data-testid="lfp_checkbox"
              >
                <span
                  class="MuiIconButton-label"
                >
                  <input
                    class="PrivateSwitchBase-input-10"
                    data-indeterminate="false"
                    type="checkbox"
                    value=""
                  />
                  <svg
                    aria-hidden="true"
                    class="MuiSvgIcon-root"
                    focusable="false"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                    />
                  </svg>
                </span>
                <span
                  class="MuiTouchRipple-root"
                />
              </span>
              <span
                class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
              >
                <div
                  class="MuiBox-root MuiBox-root-15"
                >
                  <span
                    class="MuiTypography-root MuiTypography-body2"
                  >
                    <div
                      class="MuiBox-root MuiBox-root-16"
                    >
                      I am signing up for Dr.Bill to upload my 
                    </div>
                    <div
                      class="MuiBox-root MuiBox-root-17"
                    >
                       
                      patient panel
                       
                    </div>
                    <div
                      class="MuiBox-root MuiBox-root-18"
                    >
                       to MSP.
                    </div>
                  </span>
                </div>
              </span>
            </label>
          </div>
          <div
            class="MuiBox-root MuiBox-root-19 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            data-testid="registration-step-3-category"
            style="margin-top: 30px;"
          >
            <legend
              class="MuiFormLabel-root makeStyles-legend-4"
            >
              Final Details
            </legend>
            <div
              class="MuiFormControl-root makeStyles-formControl-3"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                data-shrink="false"
                id="category-label"
              >
                What best describes you
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                >
                   
                  *
                </span>
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
              >
                <div
                  aria-haspopup="listbox"
                  aria-labelledby="category-label category"
                  class="MuiSelect-root MuiSelect-select MuiSelect-selectMenu MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                  id="category"
                  role="button"
                  tabindex="0"
                >
                  <span>
                    ​
                  </span>
                </div>
                <input
                  aria-hidden="true"
                  class="MuiSelect-nativeInput"
                  required=""
                  tabindex="-1"
                  value=""
                />
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M7 10l5 5 5-5z"
                  />
                </svg>
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-22"
                  >
                    <span>
                      What best describes you
                    </span>
                  </legend>
                </fieldset>
              </div>
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-24 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            data-testid="registration-step-3-specialty"
          >
            <div
              class="MuiFormControl-root makeStyles-formControl-3"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-disabled Mui-disabled Mui-required Mui-required"
                data-shrink="false"
                id="speciality-label"
              >
                Your speciality
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                >
                   
                  *
                </span>
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root Mui-disabled Mui-disabled MuiInputBase-formControl"
              >
                <div
                  aria-disabled="true"
                  aria-haspopup="listbox"
                  aria-labelledby="speciality-label speciality"
                  class="MuiSelect-root MuiSelect-select MuiSelect-selectMenu MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input Mui-disabled Mui-disabled Mui-disabled"
                  id="speciality"
                  role="button"
                >
                  <span>
                    ​
                  </span>
                </div>
                <input
                  aria-hidden="true"
                  class="MuiSelect-nativeInput"
                  required=""
                  tabindex="-1"
                  value=""
                />
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined Mui-disabled"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M7 10l5 5 5-5z"
                  />
                </svg>
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-22"
                  >
                    <span>
                      Your speciality
                    </span>
                  </legend>
                </fieldset>
              </div>
              <p
                class="MuiFormHelperText-root MuiFormHelperText-contained Mui-disabled Mui-required"
              >
                Please select what best describes you *
              </p>
              <p
                class="MuiFormHelperText-root MuiFormHelperText-contained Mui-disabled Mui-required"
              >
                Please select a province to bill
              </p>
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-25 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            data-testid="registration-step-3-practitioner-number"
          >
            <div
              class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-disabled Mui-disabled"
                data-shrink="false"
                for="practitioner-number"
                id="practitioner-number-label"
              >
                Practitioner number (Optional)
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root Mui-disabled Mui-disabled MuiInputBase-fullWidth MuiInputBase-formControl"
              >
                <input
                  aria-invalid="false"
                  class="MuiInputBase-input MuiOutlinedInput-input Mui-disabled Mui-disabled"
                  disabled=""
                  id="practitioner-number"
                  type="text"
                  value=""
                />
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-22"
                  >
                    <span>
                      Practitioner number (Optional)
                    </span>
                  </legend>
                </fieldset>
              </div>
              
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-27 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            data-testid="registration-step-3-phone-number"
          >
            <div
              class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                data-shrink="false"
                for="phone-number"
                id="phone-number-label"
              >
                Phone number
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                >
                   
                  *
                </span>
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
              >
                <input
                  aria-describedby="phone-number-helper-text"
                  aria-invalid="false"
                  class="MuiInputBase-input MuiOutlinedInput-input"
                  id="phone-number"
                  inputmode="numeric"
                  required=""
                  type="text"
                  value=""
                />
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-22"
                  >
                    <span>
                      Phone number
                       *
                    </span>
                  </legend>
                </fieldset>
              </div>
              <p
                class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required"
                id="phone-number-helper-text"
              >
                In case we need to contact you during your account setup.
              </p>
            </div>
          </div>
          <div
            class="MuiBox-root MuiBox-root-28 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
            data-testid="registration-step-3-facility-number"
          >
            <div
              class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
            >
              <label
                class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
                data-shrink="false"
                for="facility-number"
                id="facility-number-label"
              >
                Facility number
                <span
                  aria-hidden="true"
                  class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
                >
                   
                  *
                </span>
              </label>
              <div
                class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
              >
                <input
                  aria-describedby="facility-number-helper-text"
                  aria-invalid="false"
                  class="MuiInputBase-input MuiOutlinedInput-input"
                  id="facility-number"
                  required=""
                  style="text-transform: uppercase;"
                  type="text"
                  value=""
                />
                <fieldset
                  aria-hidden="true"
                  class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
                >
                  <legend
                    class="PrivateNotchedOutline-legendLabelled-22"
                  >
                    <span>
                      Facility number
                       *
                    </span>
                  </legend>
                </fieldset>
              </div>
              <p
                class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required"
                id="facility-number-helper-text"
              >
                This facility number will be associated with your patient panel upload.
              </p>
            </div>
          </div>
          <div
            class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          >
            <button
              class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled Mui-disabled"
              disabled=""
              form="new_user_registration"
              style="float: right;"
              tabindex="-1"
              type="submit"
            >
              <span
                class="MuiButton-label"
              >
                Go to dashboard
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiContainer-root MuiContainer-maxWidthSm"
    >
      <form
        accept-charset="UTF-8"
        action="/users"
        id="new_user_registration"
        method="post"
      >
        <input
          name="utf8"
          type="hidden"
          value="✓"
        />
        <input
          name="authenticity_token"
          type="hidden"
          value=""
        />
        <input
          id="registration_uuid"
          name="registration_uuid"
          type="hidden"
          value="foo"
        />
        <input
          id="activation_code"
          name="activation_code"
          type="hidden"
          value="bar"
        />
        <input
          id="province"
          name="province"
          type="hidden"
          value=""
        />
        <input
          id="sign_up_category"
          name="sign_up_category"
          type="hidden"
          value=""
        />
        <input
          id="speciality_id"
          name="speciality_id"
          type="hidden"
          value=""
        />
        <input
          id="practitioner_num"
          name="practitioner_num"
          type="hidden"
          value=""
        />
        <input
          id="phone_number"
          name="phone_number"
          type="hidden"
          value=""
        />
        <input
          id="lfp_enrolled"
          name="lfp_enrolled"
          type="hidden"
          value="false"
        />
        <input
          id="office_facility_code"
          name="office_facility_code"
          type="hidden"
          value=""
        />
        <input
          id="promo_code"
          name="promo_code"
          type="hidden"
          value="promo"
        />
        <input
          id="bill_share_guid"
          name="bill_share_guid"
          type="hidden"
          value="guid"
        />
        <input
          id="bill_share_token"
          name="bill_share_token"
          type="hidden"
          value="token"
        />
      </form>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3"
      >
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <h3
            class="MuiTypography-root MuiTypography-h3"
          >
            About your Practice
          </h3>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <p
            class="MuiTypography-root MuiTypography-body1"
          >
            Let us know a bit more about your practice to finish creating your account.
          </p>
          <p
            class="MuiTypography-root makeStyles-requiredFieldTxt-6 MuiTypography-body1"
          >
            * indicates required field
          </p>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <fieldset
            class="MuiFormControl-root"
          >
            <legend
              class="MuiFormLabel-root makeStyles-legend-4 Mui-required"
            >
              Which province do you bill to?
              <span
                aria-hidden="true"
                class="MuiFormLabel-asterisk"
              >
                 
                *
              </span>
            </legend>
            <div
              aria-label="Which province do you bill to?"
              class="MuiFormGroup-root"
              role="radiogroup"
            >
              <label
                class="MuiFormControlLabel-root makeStyles-body1-1"
                required=""
              >
                <span
                  aria-disabled="false"
                  class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary"
                >
                  <span
                    class="MuiIconButton-label"
                  >
                    <input
                      class="PrivateSwitchBase-input-10"
                      name="province-AB"
                      type="radio"
                      value="AB"
                    />
                    <div
                      class="PrivateRadioButtonIcon-root-11"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                        />
                      </svg>
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root PrivateRadioButtonIcon-layer-12"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                        />
                      </svg>
                    </div>
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </span>
                <span
                  class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                >
                  Alberta (AHCIP)
                </span>
              </label>
              <label
                class="MuiFormControlLabel-root makeStyles-body1-1"
                required=""
              >
                <span
                  aria-disabled="false"
                  class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary"
                >
                  <span
                    class="MuiIconButton-label"
                  >
                    <input
                      class="PrivateSwitchBase-input-10"
                      name="province-BC"
                      type="radio"
                      value="BC"
                    />
                    <div
                      class="PrivateRadioButtonIcon-root-11"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                        />
                      </svg>
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root PrivateRadioButtonIcon-layer-12"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                        />
                      </svg>
                    </div>
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </span>
                <span
                  class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                >
                  British Columbia (MSP)
                </span>
              </label>
              <label
                class="MuiFormControlLabel-root makeStyles-body1-1"
                required=""
              >
                <span
                  aria-disabled="false"
                  class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiRadio-root MuiRadio-colorSecondary MuiIconButton-colorSecondary"
                >
                  <span
                    class="MuiIconButton-label"
                  >
                    <input
                      class="PrivateSwitchBase-input-10"
                      name="province-ON"
                      type="radio"
                      value="ON"
                    />
                    <div
                      class="PrivateRadioButtonIcon-root-11"
                    >
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                        />
                      </svg>
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root PrivateRadioButtonIcon-layer-12"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
                        />
                      </svg>
                    </div>
                  </span>
                  <span
                    class="MuiTouchRipple-root"
                  />
                </span>
                <span
                  class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
                >
                  Ontario (OHIP)
                </span>
              </label>
            </div>
          </fieldset>
        </div>
        <div
          class="MuiBox-root MuiBox-root-14 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          data-testid="registration-step-3-lfp-enrollment"
          style="margin-top: 30px;"
        >
          <legend
            class="MuiFormLabel-root makeStyles-legend-4"
          >
            Patient panel upload (PAS)
          </legend>
          <label
            class="MuiFormControlLabel-root"
          >
            <span
              aria-disabled="false"
              class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-7 MuiCheckbox-root MuiCheckbox-colorPrimary MuiIconButton-colorPrimary"
              data-testid="lfp_checkbox"
            >
              <span
                class="MuiIconButton-label"
              >
                <input
                  class="PrivateSwitchBase-input-10"
                  data-indeterminate="false"
                  type="checkbox"
                  value=""
                />
                <svg
                  aria-hidden="true"
                  class="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                  />
                </svg>
              </span>
              <span
                class="MuiTouchRipple-root"
              />
            </span>
            <span
              class="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1"
            >
              <div
                class="MuiBox-root MuiBox-root-15"
              >
                <span
                  class="MuiTypography-root MuiTypography-body2"
                >
                  <div
                    class="MuiBox-root MuiBox-root-16"
                  >
                    I am signing up for Dr.Bill to upload my 
                  </div>
                  <div
                    class="MuiBox-root MuiBox-root-17"
                  >
                     
                    patient panel
                     
                  </div>
                  <div
                    class="MuiBox-root MuiBox-root-18"
                  >
                     to MSP.
                  </div>
                </span>
              </div>
            </span>
          </label>
        </div>
        <div
          class="MuiBox-root MuiBox-root-19 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          data-testid="registration-step-3-category"
          style="margin-top: 30px;"
        >
          <legend
            class="MuiFormLabel-root makeStyles-legend-4"
          >
            Final Details
          </legend>
          <div
            class="MuiFormControl-root makeStyles-formControl-3"
          >
            <label
              class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
              data-shrink="false"
              id="category-label"
            >
              What best describes you
              <span
                aria-hidden="true"
                class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
              >
                 
                *
              </span>
            </label>
            <div
              class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl"
            >
              <div
                aria-haspopup="listbox"
                aria-labelledby="category-label category"
                class="MuiSelect-root MuiSelect-select MuiSelect-selectMenu MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                id="category"
                role="button"
                tabindex="0"
              >
                <span>
                  ​
                </span>
              </div>
              <input
                aria-hidden="true"
                class="MuiSelect-nativeInput"
                required=""
                tabindex="-1"
                value=""
              />
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <path
                  d="M7 10l5 5 5-5z"
                />
              </svg>
              <fieldset
                aria-hidden="true"
                class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
              >
                <legend
                  class="PrivateNotchedOutline-legendLabelled-22"
                >
                  <span>
                    What best describes you
                  </span>
                </legend>
              </fieldset>
            </div>
          </div>
        </div>
        <div
          class="MuiBox-root MuiBox-root-24 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          data-testid="registration-step-3-specialty"
        >
          <div
            class="MuiFormControl-root makeStyles-formControl-3"
          >
            <label
              class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-disabled Mui-disabled Mui-required Mui-required"
              data-shrink="false"
              id="speciality-label"
            >
              Your speciality
              <span
                aria-hidden="true"
                class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
              >
                 
                *
              </span>
            </label>
            <div
              class="MuiInputBase-root MuiOutlinedInput-root Mui-disabled Mui-disabled MuiInputBase-formControl"
            >
              <div
                aria-disabled="true"
                aria-haspopup="listbox"
                aria-labelledby="speciality-label speciality"
                class="MuiSelect-root MuiSelect-select MuiSelect-selectMenu MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input Mui-disabled Mui-disabled Mui-disabled"
                id="speciality"
                role="button"
              >
                <span>
                  ​
                </span>
              </div>
              <input
                aria-hidden="true"
                class="MuiSelect-nativeInput"
                required=""
                tabindex="-1"
                value=""
              />
              <svg
                aria-hidden="true"
                class="MuiSvgIcon-root MuiSelect-icon MuiSelect-iconOutlined Mui-disabled"
                focusable="false"
                viewBox="0 0 24 24"
              >
                <path
                  d="M7 10l5 5 5-5z"
                />
              </svg>
              <fieldset
                aria-hidden="true"
                class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
              >
                <legend
                  class="PrivateNotchedOutline-legendLabelled-22"
                >
                  <span>
                    Your speciality
                  </span>
                </legend>
              </fieldset>
            </div>
            <p
              class="MuiFormHelperText-root MuiFormHelperText-contained Mui-disabled Mui-required"
            >
              Please select what best describes you *
            </p>
            <p
              class="MuiFormHelperText-root MuiFormHelperText-contained Mui-disabled Mui-required"
            >
              Please select a province to bill
            </p>
          </div>
        </div>
        <div
          class="MuiBox-root MuiBox-root-25 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          data-testid="registration-step-3-practitioner-number"
        >
          <div
            class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
          >
            <label
              class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-disabled Mui-disabled"
              data-shrink="false"
              for="practitioner-number"
              id="practitioner-number-label"
            >
              Practitioner number (Optional)
            </label>
            <div
              class="MuiInputBase-root MuiOutlinedInput-root Mui-disabled Mui-disabled MuiInputBase-fullWidth MuiInputBase-formControl"
            >
              <input
                aria-invalid="false"
                class="MuiInputBase-input MuiOutlinedInput-input Mui-disabled Mui-disabled"
                disabled=""
                id="practitioner-number"
                type="text"
                value=""
              />
              <fieldset
                aria-hidden="true"
                class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
              >
                <legend
                  class="PrivateNotchedOutline-legendLabelled-22"
                >
                  <span>
                    Practitioner number (Optional)
                  </span>
                </legend>
              </fieldset>
            </div>
            
          </div>
        </div>
        <div
          class="MuiBox-root MuiBox-root-27 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          data-testid="registration-step-3-phone-number"
        >
          <div
            class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
          >
            <label
              class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
              data-shrink="false"
              for="phone-number"
              id="phone-number-label"
            >
              Phone number
              <span
                aria-hidden="true"
                class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
              >
                 
                *
              </span>
            </label>
            <div
              class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
            >
              <input
                aria-describedby="phone-number-helper-text"
                aria-invalid="false"
                class="MuiInputBase-input MuiOutlinedInput-input"
                id="phone-number"
                inputmode="numeric"
                required=""
                type="text"
                value=""
              />
              <fieldset
                aria-hidden="true"
                class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
              >
                <legend
                  class="PrivateNotchedOutline-legendLabelled-22"
                >
                  <span>
                    Phone number
                     *
                  </span>
                </legend>
              </fieldset>
            </div>
            <p
              class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required"
              id="phone-number-helper-text"
            >
              In case we need to contact you during your account setup.
            </p>
          </div>
        </div>
        <div
          class="MuiBox-root MuiBox-root-28 MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
          data-testid="registration-step-3-facility-number"
        >
          <div
            class="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
          >
            <label
              class="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-outlined Mui-required Mui-required"
              data-shrink="false"
              for="facility-number"
              id="facility-number-label"
            >
              Facility number
              <span
                aria-hidden="true"
                class="MuiFormLabel-asterisk MuiInputLabel-asterisk"
              >
                 
                *
              </span>
            </label>
            <div
              class="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"
            >
              <input
                aria-describedby="facility-number-helper-text"
                aria-invalid="false"
                class="MuiInputBase-input MuiOutlinedInput-input"
                id="facility-number"
                required=""
                style="text-transform: uppercase;"
                type="text"
                value=""
              />
              <fieldset
                aria-hidden="true"
                class="PrivateNotchedOutline-root-20 MuiOutlinedInput-notchedOutline"
              >
                <legend
                  class="PrivateNotchedOutline-legendLabelled-22"
                >
                  <span>
                    Facility number
                     *
                  </span>
                </legend>
              </fieldset>
            </div>
            <p
              class="MuiFormHelperText-root MuiFormHelperText-contained Mui-required"
              id="facility-number-helper-text"
            >
              This facility number will be associated with your patient panel upload.
            </p>
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
        >
          <button
            class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary Mui-disabled Mui-disabled"
            disabled=""
            form="new_user_registration"
            style="float: right;"
            tabindex="-1"
            type="submit"
          >
            <span
              class="MuiButton-label"
            >
              Go to dashboard
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
